import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'changeNameTrxToTron',
  standalone: true
})
export class changeNameTrxToTronPipe implements PipeTransform {
  transform(str: string): string {
    if (str && str.toUpperCase() === 'TRX') {
      return 'TRON';
    }
    return str;
  }
}
